export default class SkipSetupController {
  constructor($scope, $uibModalInstance) {
    this.$uibModalInstance = $uibModalInstance;
  }

  dismiss(check) {
    this.$uibModalInstance.close(check);
  }
}



// WEBPACK FOOTER //
// ./app/pages/complete-migration/modals/skip-setup.js